import React, { useEffect } from "react";
import TypingText from "../common/TypingText";
import CarrouselText from "../common/CarrouselText";
import { OpenInNew } from "@mui/icons-material";
import { Verified } from "@mui/icons-material";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const HomeSection = () => {
  const WORDS = [
    "Servicios turísticos y empresariales, todo en uno.",
    "Interpretación en reuniones, fábricas y ferias durante tus viajes de negocios.",
    "Paquete de tour privado en español de la puerta de tu hotel a la historia viva.",
  ];

  const scrollToElement = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      className="relative min-h-screen w-full overflow-x-hidden flex items-center justify-center text-center text-white z-10 box-border"
    >
      {/* 👇 NUEVA FRASE FIJA EN LA ESQUINA SUPERIOR IZQUIERDA */}
      <div
        data-aos="fade-down"
        className="absolute top-36 sm:top-40 transform z-30
             bg-black bg-opacity-60 text-white
             text-base sm:text-lg md:text-xl
             rounded-xl px-6 py-4 shadow-[0_0_30px_rgba(255,255,255,0.1)]
             backdrop-blur-md border border-white/20
             hover:shadow-[0_0_40px_10px_rgba(255,255,255,0.15)]
             transition-all duration-500 group
             inline-flex items-center gap-3
             whitespace-normal sm:whitespace-nowrap
             max-w-[90vw] sm:max-w-none"
      >
        <LocationOnIcon className="text-yellow-400 animate-pulse" />
        <p>
          <span className="font-semibold text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 via-pink-400 to-red-500 drop-shadow">
            Con sede en Beijing,
          </span>{" "}
          especialistas en tours y servicio de interpretación por toda China.
        </p>
      </div>

      {/* VIDEO */}
      <video
        className="absolute top-0 left-0 w-full h-full object-cover"
        autoPlay
        muted
        loop
        playsInline
      >
        <source
          src="https://res.cloudinary.com/ddx3pzjlm/video/upload/v1751672828/Background_home_cyqtyg.mp4"
          type="video/mp4"
        />
        Tu navegador no soporta videos HTML5.
      </video>

      <div className="absolute inset-0 bg-black bg-opacity-60 z-10" />

      <div className="relative z-20 flex flex-col items-center justify-center h-full px-4 sm:px-6 md:px-8 py-6 pt-32 md:pt-0 box-border">
        <h1
          data-aos="fade-up"
          className="text-5xl md:text-7xl font-extrabold leading-tight mb-6 drop-shadow-xl"
        >
          Bienvenido a{" "}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-pink-500 to-red-600">
            ViajeChinaConLulu
          </span>
        </h1>

        {/*<TypingText words={WORDS} useGradient={false} />*/}
        <CarrouselText words={WORDS} useGradient={false} delay={3000} />

        {/* Botones alineados horizontalmente */}
        <div
          data-aos="fade-up"
          data-aos-delay="400"
          className="flex flex-wrap gap-4 justify-center mt-8"
        >
          <a
            href="https://wa.me/8613683676407?text=Hola,%20estoy%20interesado%20en%20tus%20viajes%20a%20China."
            target="_blank"
            rel="noopener noreferrer"
            className="group px-4 sm:px-8 py-4 rounded-full text-xl font-semibold inline-flex items-center gap-2 bg-purple-600 text-white hover:bg-purple-700 transition-all transform hover:scale-105 shadow-lg hover:shadow-[0_0_40px_10px_rgba(192,132,252,0.6)]"
          >
            Reserva tu Tour con Nosotros!
            <OpenInNew className="transition-transform group-hover:rotate-45" />
          </a>

          <button
            onClick={() => scrollToElement("about")}
            className="group px-8 py-4 rounded-full text-xl font-semibold bg-blue-600 hover:bg-blue-700 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-[0_0_40px_10px_rgba(59,130,246,0.8)] flex items-center gap-2"
          >
            Sobre Nosotros
            <Verified
              size={28}
              className="text-white group-hover:animate-bounce transition-transform"
            />
          </button>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-b from-transparent to-black z-20" />
    </section>
  );
};

export default HomeSection;
